import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FaFilePdf, FaTimes } from 'react-icons/fa';
import Viewer from '@/components/pdf/Viewer';

const Step5 = ({ certificados, selectedCertificado, setSelectedCertificado }) => {
  const [selectedCertificadoLocal, setSelectedCertificadoLocal] = useState(selectedCertificado);
  const [showModal, setShowModal] = useState(false);
  const [pdfBase64, setPdfBase64] = useState("");
  const [isLoadingPdf, setIsLoadingPdf] = useState(false);

  useEffect(() => {
    setSelectedCertificadoLocal(selectedCertificado);
  }, [selectedCertificado]);

  const handleCertificadoSelect = (certificado) => {
    setSelectedCertificadoLocal(certificado);
    setSelectedCertificado(certificado);
  };

  const handleViewPdf = async (e, md5) => {
    e.stopPropagation();
    if (md5) {
      setShowModal(true);
      setIsLoadingPdf(true);
      setPdfBase64("");
      try {
        const url = `/api/proxy-pdf?id=${md5}`;
        const response = await fetch(url);
        const blob = await response.blob();

        const reader = new FileReader();
        reader.onloadend = () => {
          const base64String = reader.result;
          const pureBase64 = base64String.split(',')[1];
          setPdfBase64(pureBase64);
          setIsLoadingPdf(false);
        };
        reader.readAsDataURL(blob);
      } catch (error) {
        console.error("Error al cargar el PDF mediante fetch:", error);
        setIsLoadingPdf(false);
      }
    }
  };

  return (
    <div>
      <h2 className="text-xl font-semibold mb-4">
        {selectedCertificadoLocal ? "Certificado de Avalúo seleccionado" : "Seleccione un Certificado de Avalúo"}
      </h2>
      {certificados.length === 0 ? (
        <p>No hay certificados de avalúo pendientes disponibles para este predio.</p>
      ) : (
        <div className="space-y-4 max-h-125 overflow-y-auto">
          {certificados.map((certificado) => (
            <div
              key={certificado.id}
              className={`relative border p-4 rounded-md cursor-pointer ${selectedCertificadoLocal?.id === certificado.id ? 'bg-blue-100 border-blue-400' : 'hover:bg-gray-50'}`}
              onClick={() => handleCertificadoSelect(certificado)}
            >
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-2 pr-12">
                <p><strong>Clave:</strong> {certificado.clave}</p>
                <p className="md:col-span-2 lg:col-span-2"><strong>Dirección:</strong> {certificado.Direccion}</p>
                <p><strong>Área Terreno:</strong> {certificado.AreaTerr}</p>
                <p><strong>Avalúo Terreno:</strong> {certificado.AvaluoTerr}</p>
                <p><strong>Área Construcción:</strong> {certificado.AreaConst}</p>
                <p><strong>Avalúo Construcción:</strong> {certificado.AvaluoConst}</p>
                <p><strong>Fecha Adquisición:</strong> {certificado.FAdquisicion}</p>
              </div>

              {certificado.md5 && (
                <button
                  onClick={(e) => handleViewPdf(e, certificado.md5)}
                  className="absolute top-4 right-4 p-2 text-red-500 hover:text-red-700 transition-colors"
                  title="Ver PDF"
                >
                  <FaFilePdf size={24} />
                </button>
              )}
            </div>
          ))}
        </div>
      )}

      {/* Modal para el visor de PDF */}
      {showModal && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50 p-4">
          <div className="relative w-full max-w-5xl h-[90vh] rounded-lg bg-white p-6 shadow-xl flex flex-col">
            <div className="mb-4 flex items-center justify-between border-b pb-2">
              <h3 className="text-lg font-bold text-gray-800">Vista Previa del Certificado</h3>
              <button
                onClick={() => setShowModal(false)}
                className="text-gray-500 hover:text-gray-700 transition-colors"
              >
                <FaTimes size={20} />
              </button>
            </div>

            <div className="flex-1 min-h-0">
              <Viewer isLoading={isLoadingPdf} base64={pdfBase64} />
            </div>

            <div className="mt-4 flex justify-end">
              <button
                onClick={() => setShowModal(false)}
                className="rounded bg-primary px-4 py-2 text-white hover:bg-opacity-90 transition-colors"
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

Step5.propTypes = {
  certificados: PropTypes.array.isRequired,
  setSelectedCertificado: PropTypes.func.isRequired,
  selectedCertificado: PropTypes.object,
};

export default Step5;